import { render, staticRenderFns } from "./AddRequiredStockModal.vue?vue&type=template&id=61857dcc"
import script from "./AddRequiredStockModal.vue?vue&type=script&lang=ts"
export * from "./AddRequiredStockModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports